export default __webpack_public_path__ + "static/spiritual-india-places-2-1a79cde40bb50d591610499bb12a4c98.jpg";